import { useMediaQuery } from ".";

export function useIsDesktop() {
  return useMediaQuery("(min-width: 768px)");
}
